import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import type { RadioGroupProps } from '@mui/material/RadioGroup';

const StyledRadioGroup = styled(RadioGroup)<RadioGroupProps>({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px',
  marginBottom: 0,
});

export default StyledRadioGroup;
